import { render } from "./ResetPassword.vue?vue&type=template&id=622b6b71&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=622b6b71&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b6b71"]])

export default __exports__